export const vibrantsData = [
  // --- CORE VIBRANTS (8) ---
  {
    id: 1,
    title: "Vibrant Body",
    category: "Core",
    tagline: "Fuel your body with energy through nutrition, movement, and restorative practices.",
    description: "Your body is your first home. At GoodVibe, we guide you in cultivating strength, vitality, and resilience through wholesome nutrition, joyful movement, and restorative routines that refresh and energize you.",
    items: [
      "Fuel your Body with 'Vibrant Foods'",
      "Move Your Body with 'Vibrant Poses'",
      "Have a good Sleep that generate 'Peaceful Healing Vibrations'"
    ],
    icon: "FaRunning" 
  },
  {
    id: 2,
    title: "Vibrant Mind",
    category: "Core",
    tagline: "Nurture mental clarity, focus, and emotional resilience.",
    description: "A vibrant mind is the cornerstone of wellbeing. Learn practical techniques to sharpen your focus & attention, find inner peace, manage stress, and build emotional resilience.",
    items: [
      "Emotional Balance & Resilience",
      "Develop Inner peace & poise",
      "Power your mind with Vibrant Energies",
      "Sharpen Mental Clarity & Focus",
      "Regular Detoxification & Decluttering"
    ],
    icon: "FaBrain"
  },
  {
    id: 3,
    title: "Vibrant Wisdom",
    category: "Core",
    tagline: "Cultivate deep insight and clarity to think clearly, choose wisely, and live meaningfully.",
    description: "Vibrant Wisdom & Intellect is the combination of knowledge, critical thinking, insight, and practical understanding applied in ways that enhance life, decision-making, and personal growth.",
    items: [
      "Path, practices & Tools to create Wisdom",
      "Lifelong Learning & Intellectual Growth",
      "Insight & Reflective Wisdom",
      "Cognitive Clarity",
      "Creative Intelligence",
      "Practical Decision-Making"
    ],
    icon: "FaBookOpen"
  },
  {
    id: 4,
    title: "Vibrant Skills",
    category: "Core",
    tagline: "Develop your skills and abilities to their fullest potential.",
    description: "Vibrant Skills are the abilities that bring energy, purpose, and mastery to your life. They help you adapt, grow, and succeed—whether in daily tasks, personal growth, or meaningful connections.",
    items: [
      "Basic Skills (Foundational)",
      "Life Skills (Practical management)",
      "Wellbeing Skills (Life balancing)",
      "Moral Skills (Character & Integrity)",
      "Focus & Attention",
      "Sensory & Creative Living Skills",
      "Technical & Digital Skills"
    ],
    icon: "FaTools"
  },
  {
    id: 5,
    title: "Vibrant Economy",
    category: "Core",
    tagline: "Build financial health and skills for individual prosperity.",
    description: "Vibrant Economy is about creating financial stability, smart resource management, and sustainable wealth that supports a fulfilling life. It's about using resources wisely to build abundance.",
    items: [
      "Financial Literacy (Budgeting, saving, investing)",
      "Financial Skills (Savings, Borrowing, Accounting)",
      "Income Diversification",
      "Skill Investment",
      "Mindful Spending",
      "Community & Social Economic Vibrance"
    ],
    icon: "FaCoins"
  },
  {
    id: 6,
    title: "Vibrant Connections",
    category: "Core",
    tagline: "Build meaningful connections that uplift and support you.",
    description: "Vibrant Relationships are connections that energize, uplift, and nurture all people involved. They are healthy, meaningful, and mutually supportive, bringing clarity, joy, and growth into life.",
    items: [
      "Core Connection Skills",
      "Communication Mastery",
      "Joy & Positive Energy",
      "Deep Relationship Skills",
      "Collaboration & Social Harmony",
      "Conflict Resolution & Resilience"
    ],
    icon: "FaHandsHelping"
  },
  {
    id: 7,
    title: "Vibrant Spirit",
    category: "Core",
    tagline: "Cultivate inner peace, purpose, and alignment with your higher self.",
    description: "Vibrant Spirit is the inner energy that connects you to meaning, purpose, peace, and a higher sense of life. It is your inner light, your values, and your conscience.",
    items: [
      "Inner Stillness & Awareness",
      "Purpose & Meaning Activation",
      "Live a Life Guided by Principles",
      "Practice Gratitude & Appreciativeness",
      "Compassionate & Kindness Living",
      "Energy Balance, Cleansing & Renewal"
    ],
    icon: "FaSpa"
  },
  {
    id: 8,
    title: "Vibrant Nature",
    category: "Core",
    tagline: "Reconnect with nature to restore balance and peace.",
    description: "Vibrant Nature is about connecting deeply with nature and living in harmony with it. It nurtures a sense of wonder, balance, and responsibility toward the natural world. Vibrant Nature invites a deep reconnection with nature, fostering harmony, reverence, and conscious care for all life.",
    items: [
      "Create a 'Vibrant Space' at home",
      "Use 'Vibrant Colors' of Nature",
      "Expose oneself to Nature Therapies",
      "Reconnect to restore balance",
      "Protecting and nurturing the natural world",
      "Aligning biorhythms with Nature rhythms"
    ],
    icon: "FaTree"
  },

  // --- ACCELERATOR VIBRANTS (4) ---
  {
    id: 9,
    title: "Differently Vibrant",
    category: "Accelerator",
    tagline: "Vibrance appears in many shapes, minds, and expressions.",
    description: "Differently Vibrant celebrates the individuality of one's journey. It is about embracing what makes each person unique and transforming it into a personal source of energy, confidence, and purpose.",
    items: [
      "Celebrate Uniqueness & Individual Expression",
      "Deepening Humanity skills",
      "Equity & Equality in Practice",
      "Inclusive Mindset & Respect for All",
      "Accessibility & Universal Participation",
      "Empathy, Compassion & Understanding"
    ],
    icon: "FaFingerprint"
  },
  {
    id: 10,
    title: "Digitally Vibrant",
    category: "Accelerator",
    tagline: "We believe technology can elevate life when used with intention.",
    description: "Digitally Vibrant inspires a mindful and empowered digital experience. It is about using the digital world to energize your life, not drain it, building healthy, meaningful, and energizing online habits.",
    items: [
      "Digital Literacy & Skills",
      "Mindful Digital Habits",
      "Safe & Responsible Online Behavior",
      "Positive Digital Presence & Impact",
      "Digital Kindness & Wellbeing",
      "Creativity & Innovation in Digital Space"
    ],
    icon: "FaLaptopCode"
  },
  {
    id: 11,
    title: "Universally Vibrant",
    category: "Accelerator",
    tagline: "Vibrance grows when we connect with something larger than ourselves.",
    description: "Universally Vibrant reflects a state of global harmony among people, communities, and the planet. It is about awakening shared wellbeing, positive energy, and collective upliftment where every life contributes to a more vibrant world and a living universe. It represents a holistic state of wellbeing in which individuals, communities, and ecosystems thrive in balance. Rooted in conscious harmony, it invites human life to flow in alignment with the universal rhythm of nature and existence. When we become vibrant individually, we naturally elevate the collective, making the entire universe a more vibrant and harmonious place.",
    items: [
      "Deepening Higher Self Awareness",
      "Inclusive & Empathetic",
      "Global Awareness & Responsibility",
      "Social & Environmental Stewardship",
      "Ethical & Conscious Living",
      "Fostering intergenerational wellbeing"
    ],
    icon: "FaGlobeAmericas"
  },
  {
    id: 12,
    title: "Sustainably Vibrant",
    category: "Accelerator",
    tagline: "Thrive fully, live lightly, and shine for the long run",
    description: "At GoodVibe, being sustainably vibrant means thriving in a way that honors both your well-being and the world around you. It's about making choices that fuel your energy, nurture your body and mind, and protect our planet. Sustainability is not just about environment; it's about creating lasting habits, mindful connections, and resilient lifestyles that keep you vibrant for the long term.",
    items: [
      "Mindful Lifestyle Choices",
      "Eco-Friendly Practices",
      "Leaning & Minimalism in Practice",
      "Mental & Emotional Sustainability",
      "Learning & Growth",
      "Vibrant Community Engagement"
    ],
    icon: "FaSun" // Based on the sun icon in your screenshot
  }
];